import {useEffect} from 'react';
import useTypedDispatch from '../../common/useTypedDispatch';
import useTypedSelector from '../../common/useTypedSelector';
import {GNB_MENU_LIST} from '../../domain/menu/constant';
import {setIsMobileGnbExposed} from '../../domain/menu/util/MenuSlice';
import {MobileTopMainHomeTab} from '../organisms/MobileTopMainHomeTab/MobileTopMainHomeTab';

export function MobileLayoutGnb() {
  const {selectedGnbMenuId} = useTypedSelector(state => ({
    selectedGnbMenuId: state.menu.selectedGnbMenuId,
  }));

  const dispatch = useTypedDispatch();
  useEffect(() => {
    dispatch(setIsMobileGnbExposed(true));
    return () => {
      dispatch(setIsMobileGnbExposed(false));
    };
  }, [dispatch]);

  return (
    <MobileTopMainHomeTab
      tabItems={GNB_MENU_LIST}
      currentTabItemId={selectedGnbMenuId as string}
    />
  );
}
